import Phaser from 'phaser';
import ScreenContainer from '../display/ui/ScreenContainer';
import ScreenOverlayImage from 'app/ui/overlays/ScreenOverlayImage';
import TutorialOverlay from '../ui/tutorial/TutorialOverlay';
import Level from '../games/chase/game/Level';
import ControllerTouch from '../games/chase/controllers/ControllerTouch';
import ControllerKeyboard from '../games/chase/controllers/ControllerKeyboard';
import GameHud from '../games/chase/ui/GameHud';

export default class MiniGameChase extends Phaser.State {
  init({ locationid }) {
    this.locationid = locationid;
  }

  create() {
    this.container = new ScreenContainer(this.game);

    this.state = MiniGameChase.STATE_INTRO;
    this.time = MiniGameChase.TIME_GAME; // game time
    this.score = 0;

    // level
    this.levelData = this.game.cache.getJSON('chasegame_data');
    this.level = new Level(this.game, this.levelData, this.time);
    this.level.onGameEnd.add(this.handleGameOver, this);
    this.level.onGameLost.add(this.handleGameLost, this);
    this.level.onCatchVillain.add(this.handleCatchVillain, this);
    this.container.addChild(this.level);

    // game hud
    this.gameHud = new GameHud(this.game);
    this.game.add.existing(this.gameHud);

    //
    this.controller1 = new ControllerTouch(this.game, this.level.hero);
    if (this.game.device.desktop) {
      this.controller2 = new ControllerKeyboard(this.game, this.level.hero);
    }

    if (!this.game.gameController.player.getTutorialSeen('chasegame')) {
      this.game.gameController.player.setTutorialSeen('chasegame');
      this.showTutorial();
    } else {
      this.handleContinueGame();
    }

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
    this.positionElements();

    //
    this.game.sounds.playSpriteSFX('music', {
      spriteID: 'game_audiosprite',
      loop: true,
      volume: 0.3,
    });
  }

  positionElements() {
    this.level.x = (this.game.defaultWidth - this.game.width) / 2;
  }

  showTutorial() {
    const tutorial = [
      {
        copy: this.game.copy.getCopy('chasegame_instruction_01'),
        image: 'chase_monster',
      },
      {
        copy: this.game.copy.getCopy('chasegame_instruction_02'),
        image: 'chase_jump_all',
      },
    ];
    this.tutorial = new TutorialOverlay(this.game, tutorial);
    this.tutorial.onComplete.add(this.handleContinueGame, this);
    this.game.add.existing(this.tutorial);
  }

  handleContinueGame() {
    this.tutorial = null;
    this.state = MiniGameChase.STATE_PLAY;
    this.level.start();
    this.controller1.start();
    if (this.controller2) this.controller2.start();
  }

  update() {
    let dt = Math.min(0.05, this.game.time.elapsedMS / 1000);

    if (this.state == MiniGameChase.STATE_PLAY) {
      this.time -= dt;
      this.time = Math.max(0, this.time);
      this.gameHud.setTime(this.time / MiniGameChase.TIME_GAME);

      // play clock sound
      if (this.time < 5) {
        if (!this.sndClock) {
          this.sndClock = this.game.sounds.playSpriteSFX('clock', {
            spriteID: 'game_audiosprite',
            ignoreIfPlaying: true,
            volume: 1,
          });
        } else {
          let volume = 2 + 4 * (1 - this.time / 5);
          this.sndClock.volume = volume;
        }
      }

      if (this.time <= 0) {
        // game over
        this.state = MiniGameChase.STATE_END;
        this.controller1.stop();
        if (this.controller2) this.controller2.stop();

        if (this.levelData.catch_villain) {
          this.handleGameOver(true);
        } else {
          this.level.endLevel();
        }

        this.game.sounds.stopSFX('clock', {
          spriteID: 'game_audiosprite',
        });
      }

      //
      this.level.step(dt, this.time);
    } else if (this.state == MiniGameChase.STATE_END) {
      this.level.step(dt);
    }
  }

  handleGameOver(won) {
    if (!won) {
      this.state = MiniGameChase.STATE_SUMMARY;
      this.gameHud.showSummary();
    } else {
      this.game.gameController.endMiniGame();
    }
  }

  handleGameLost() {
    this.state = MiniGameChase.STATE_END;
    this.controller1.stop();
    if (this.controller2) this.controller2.stop();
  }

  handleCatchVillain() {
    this.controller1.stop();
    if (this.controller2) this.controller2.stop();
    this.handleGameOver(true);
  }

  shutdown() {
    this.game.sounds.stopSFX('music', { spriteID: 'game_audiosprite' });

    this.game.scale.onSizeChange.remove(this.positionElements, this);
    this.level.onGameEnd.remove(this.handleGameOver, this);
    this.level.onGameLost.remove(this.handleGameLost, this);
    this.level.onCatchVillain.remove(this.handleCatchVillain, this);

    this.gameHud.destroy();
    this.level.destroy();
    this.controller1.stop();
    if (this.controller2) this.controller2.stop();

    this.gameHud = null;
    this.level = null;
    this.controller1 = null;
    this.controller2 = null;
    this.tutorial = null;
  }
}

MiniGameChase.STATE_INTRO = 1;
MiniGameChase.STATE_PLAY = 2;
MiniGameChase.STATE_END = 3;
MiniGameChase.STATE_SUMMARY = 4;

MiniGameChase.TIME_GAME = 30; //4 to test game over



// WEBPACK FOOTER //
// ./js/app/states/MiniGameChase.js